
import { ISanPhamEditRequest } from "../../../model/request/san-pham/ISanPhamEditRequest"
import { ISanPhamImportRequest } from "../../../model/request/san-pham/ISanPhamImportRequest"
import { ISanPhamImportResponse } from "../../../model/respone/common/ISanPhamImportResponse"
import { ISanPham } from "../../../model/respone/san-pham/ISanPham"
import { ISanPhamChiTiet } from "../../../model/respone/san-pham/ISanPhamChiTiet"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eSanPhamActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ISanPham[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISanPham,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ISanPhamEditRequest,
    SAVE_SUCCESS: {} as number,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_ID: 0,
    CHANGE_CATEGORY_SELECTED_ID: 0,

    UPDATE_THUMB_MAIN_SUCCESS: {} as ISanPham,

    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,

    SAVE_IMPORT_START: {} as ISanPhamImportRequest,
    SAVE_IMPORT_SUCCESS: {} as ISanPhamImportResponse,
    SAVE_IMPORT_ERROR: "",
}
export const eSanPhamActionTypeIds = generateActionTypeIds(eSanPhamActionTypeDefine, "SAN_PHAM")

export type ISanPhamActions = IGenericActionType<typeof eSanPhamActionTypeDefine, "SAN_PHAM">